import styled from "styled-components";
import { Color } from "../../../../../../themes/definitions/casino777/casino777-colors";
import {LiveCasinoGridItemClosedMessageDefaultBox} from "./live-casino-grid-item-closed-message.default.box";

export const LiveCasinoGridItemClosedMessageCasino777Box = styled(LiveCasinoGridItemClosedMessageDefaultBox)`
  &::after {
    background: linear-gradient(90deg, transparent, ${Color.tan} 33%, ${Color.tan} 67%, transparent);
  }
`;
